"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = require("../../tema");
var Paginador_1 = __importDefault(require("./Paginador"));
function Carrossel(_a) {
  var children = _a.children,
    indiceDoVisivel = _a.indiceDoVisivel,
    aoMudarDePagina = _a.aoMudarDePagina;
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(rebass_1.Flex, {
    sx: {
      flexDirection: "column",
      alignItems: "center",
      ".paginador": {
        mb: 4
      },
      ".pagina": {
        width: "100%"
      }
    }
  }, react_1.default.createElement(Paginador_1.default, {
    aoClicarNaPagina: aoMudarDePagina,
    total: children.length,
    indiceDoAtivo: indiceDoVisivel
  }), react_1.default.createElement(rebass_1.Flex, {
    className: "pagina"
  }, children[indiceDoVisivel])));
}
exports.default = Carrossel;